export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9989_PLACING_CALL': 'Compas is connecting your call to Teams',
    '_9994_TAKE_30_SECONDS': 'This may take up to 30 seconds',
    '_11030_CALL_CREATED___': 'Call created...',
    '_11046_ESTABLISHING_CALL___': 'Establishing call...',
    '_11047_CALL_ESTABLISHED____INVITING_': 'Call established... Inviting participants...',
    '_11031_THE_CALL_HAS_BEEN_CONNECTED_': 'The call has been connected.',
    '_11048_THE_CALL_HAS_FAILED_': 'The call has failed.',
    '_9425_OK': 'OK',
    '_11049_END_THE_CALL': 'End the Call',
    '_11050_RETRY': 'Retry'
};
